import styles from './BetaTag.module.css';

export const BetaTag = () => {
  return <span className={styles.tag}>BETA</span>;
};
